import TaxUploadsBoard from '../components/dashboard/TaxUploadsBoard';
import CfdiSecureRequestBoard from '../components/dashboard/CfdiSecureRequestBoard';

function ImpuestosView({
  derivedTaxSummary,
  taxUploadMonths,
  taxUploadYears,
  derivedTaxSchedule,
  taxDueLegend,
  taxUploadChecklist,
  activitySummaryData,
  activityStatusLegend,
  session,
  activityResponsablesDirectory,
  userDirectory,
  clientDirectory,
  CALENDARIO_TABLE_ID
}) {
  return (
    <section data-ui-view="impuestos" data-ui-section="impuestos-view">
      <CfdiSecureRequestBoard
        clientDirectory={clientDirectory}
        requestedBy={session?.email || session?.displayName || ''}
      />
      <TaxUploadsBoard
        summary={derivedTaxSummary}
        months={taxUploadMonths}
        years={taxUploadYears}
        schedule={derivedTaxSchedule}
        legend={taxDueLegend}
        checklist={taxUploadChecklist}
        activitySummary={activitySummaryData}
        activityLegend={activityStatusLegend}
        userSession={session}
        responsablesDirectory={activityResponsablesDirectory}
        userDirectory={userDirectory}
        clientDirectory={clientDirectory}
        calendarioTableId={CALENDARIO_TABLE_ID}
      />
    </section>
  );
}

export default ImpuestosView;
